// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_kfI","cls2":"ClaimEvaluationRow-cls2_Ou1 ClaimEvaluationRow-cls1_kfI"};